import React from 'react';
import { Link } from 'react-router-dom';
import {Phone, Mail, MapPin, Printer} from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-[#4AB8D8] to-[#3A9AB8] text-white" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://static.lumi.new/42/42f04f93cd21eb52ed781bb36b9aa9d7.webp" 
              alt="EmergeNC Diagnostics Logo" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm mb-4 text-white/90">Professional outpatient laboratory services committed to accuracy, reliability, and exceptional patient care.</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-[#F8A356]">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services" className="hover:text-[#F4C842] transition-colors text-white/90">Our Services</Link></li>
              <li><Link to="/test-catalog" className="hover:text-[#F4C842] transition-colors text-white/90">Test Catalog</Link></li>
              <li><Link to="/appointment" className="hover:text-[#F4C842] transition-colors text-white/90">Book Appointment</Link></li>
              <li><Link to="/patient-resources" className="hover:text-[#F4C842] transition-colors text-white/90">Patient Resources</Link></li>
              <li><Link to="/faq" className="hover:text-[#F4C842] transition-colors text-white/90">FAQ</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-[#F8A356]">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" aria-hidden="true" />
                <span>4801 Glenwood Ave Suite 200 PMB 333, Raleigh, NC 27612</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0" aria-hidden="true" />
                <a href="tel:9842309599" className="hover:text-[#F4C842] transition-colors text-white/90">(984) 230-9599</a>
              </li>
              <li className="flex items-center gap-2">
                <Printer className="w-4 h-4 flex-shrink-0" aria-hidden="true" />
                <span>Fax: (984) 231-7779</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0" aria-hidden="true" />
                <a href="mailto:info@EmergeNCDiagnostics.com" className="hover:text-[#F4C842] transition-colors text-white/90">info@EmergeNCDiagnostics.com</a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-[#F8A356]">Business Hours</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex justify-between">
                <span className="font-medium">Monday - Friday:</span>
                <span>8:00 AM - 5:00 PM</span>
              </li>
              <li className="flex justify-between">
                <span className="font-medium">Saturday:</span>
                <span>8:00 AM - 2:00 PM</span>
              </li>
              <li className="flex justify-between">
                <span className="font-medium">Sunday:</span>
                <span>8:00 AM - 2:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-sm text-center">
          <p className="text-white/90">&copy; {new Date().getFullYear()} EmergeNC Diagnostics, LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
